/**
 * Internal dependencies
 */

import { makeLayout, render } from 'lib/controller';

import { index, locations, ftp, data } from './controller';
import { sidebar } from '../controller';

export default (router) => {
    router(`/settings`, sidebar, index, makeLayout, render);
    router(`/settings/data`, sidebar, data, makeLayout, render);
    router(`/settings/locations`, sidebar, locations, makeLayout, render);
    router(`/settings/ftp`, sidebar, ftp, makeLayout, render);
};